module.exports = __webpack_public_path__ + "img/anxiety.03ed1c46.svg";